module.exports = __webpack_public_path__ + "img/logo_b.730e597f.png";